import React, { useState } from 'react'
import LeftNotificationPopup from '../../core/NotificationPopup/LeftNotificationPopup';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { cancelSubscription } from '../../../backend-services/subscription';
import { Button, SidebarDrawer } from '../../common';


interface cancelSubscriptionPromptProps {
  showPrompt: boolean;
  show: any;
  onClose?: () => void;
  onDeleteSuccess?: () => void;
}

const CancelSubscriptionPrompt = ({ showPrompt, show, onClose, onDeleteSuccess }: cancelSubscriptionPromptProps) => {

  const [isCanceling, setIsCanceling] = useState(false)
  const [showSuccessSidebar, setShowSuccessSidebar] = React.useState(false);

  const closeSuccessSidebar = () => {
    setShowSuccessSidebar(false);
  };

  const handleCancelSubscription = async () => {
    setIsCanceling(true)
    try {
      const res = await cancelSubscription()
      setIsCanceling(false)
      onDeleteSuccess && onDeleteSuccess()
      setShowSuccessSidebar(true)

    } catch (error: any) {
      toast.error(error.response?.data || error.message)
      setIsCanceling(false)
      throw new Error(error.message)

    }
  }

  return (
    <>
      <div className="h-screen">
        <div className="flex max-w-[350px] md:max-w-full mx-auto md:mx-0 text-center justify-center mt-[13px] ">
            <h1>Are you sure you want to cancel subscription ? You will not be charged on the next subscription date.</h1>
          </div>
          <div role="form" onSubmit={(e) => e.preventDefault()}>
            <div className="flex space-x-[24px] pt-[79px] pb-[40px]">
              <button onClick={onClose} className='border border-[#044E97] rounded-[4px] w-1/2 md:w-[239px] py-[11px] px-[13px] md:py-[16px] md:px-[34px] text-[#044E97] text-[16px] whitespace-nowrap' style={{fontWeight: 600}}>
                Continue Plan
              </button>
              <button
                className="w-1/2 md:w-[239px] rounded-[4px] h-[55px] bg-[#FB0303] text-white font-semibold"
                onClick={handleCancelSubscription}
                disabled={isCanceling}
              >
                {isCanceling ? 'Canceling...' : 'Cancel'}
              </button>
            </div>
          </div>
      </div>
      {showSuccessSidebar && (
        <SidebarDrawer title="" show={true} position="left" onClose={closeSuccessSidebar}>
          <LeftNotificationPopup
            title="Subscription Canceled"
            icon={<ProcessSuccessful />}
            position="left"
            showSuccessModal={true}

          />
        </SidebarDrawer>
      )}
    </>
  )
}

export default CancelSubscriptionPrompt